import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { DropdownButton, Dropdown } from 'react-bootstrap'
import { addDefaultSort } from './deps'
import sortByIcon from 'src/images/sortby.svg'
import {
  application,
  i18nTranslate,
  enablePlpRedesign,
  rememberFocusTarget,
  restoreFocusAfterRemount,
} from 'src/utils'
import { IS_BROWSER } from 'config/appConfig'
import { pageNames } from 'src/routes/pathParams'
import './styles.scss'
import { IoIosSwap } from 'react-icons/io'

const SORT_TOGGLE_ID = 'plp-sort-toggle'

@observer
class ProductSort extends React.Component {
  nameSpace = 'ssr-resource'
  sortWrapperRef = React.createRef()
  constructor(props) {
    super(props)
    this.toggleId = props.toggleId || SORT_TOGGLE_ID
  }
  @observable direction = 'down'
  @observable selectedSortOption = ''
  // starts empty on both server and initial client render to avoid an SSR/CSR class mismatch
  @observable currentPathname = ''
  selectedSortId = 'featured'
  defaultSortId = 'featured'

  sortUpdateFunc = () => {
    const { sortOptions } = this.props
    const selectedOption = sortOptions.find(option => {
      if (
        option?.key != 'sort_string_product_name ASC' &&
        option?.key != 'sort_string_product_name DESC' &&
        option?.key != 'sort_number_relevancyRank ASC' &&
        option?.key != 'sort_number_relevancyRank DESC'
      ) {
        return option.selected === true
      }
    })

    // this.selectedSortOption = selectedOption
    //   ? selectedOption.name
    //   : catalogDeps.isFeaturedSelected
    //   ? i18nTranslate('plp.featuredText', 'Featured')
    //   : i18nTranslate('plp.sortByText', 'Sort By')
    this.selectedSortId = selectedOption?.key || this.defaultSortId
    this.selectedSortOption =
      selectedOption?.name ||
      i18nTranslate('plp.BestMatch', 'Best Match', {
        nameSpace: this.nameSpace,
      })
  }
  componentDidMount() {
    this.sortUpdateFunc()
    this.updateCurrentPathname()
    this.focusRestoreTimer = restoreFocusAfterRemount()
  }
  componentDidUpdate() {
    this.sortUpdateFunc()
    this.updateCurrentPathname()
  }
  componentWillUnmount() {
    clearTimeout(this.focusRestoreTimer)
  }
  // reading window.location here (post-mount/update) triggers a real re-render
  // instead of a hydration diff, so the class name actually gets applied/updated
  updateCurrentPathname = () => {
    if (IS_BROWSER && this.currentPathname !== window.location.pathname) {
      this.currentPathname = window.location.pathname
    }
  }
  handleSort = (eventKey, event) => {
    const selectedSort = eventKey
    this.selectedSortOption = event.target.innerText

    let sortValue = ''
    if (selectedSort) {
      const [sortField, sortDirection = ''] = selectedSort.split(' ')
      sortValue = { sortField, sortDirection }
    }
    const toggleButton =
      this.sortWrapperRef.current?.querySelector('.dropdown-toggle')
    toggleButton?.focus()
    // the PLP's loading placeholder can still unmount/remount this dropdown
    // while refetching; remember the toggle so focus can be restored then too
    rememberFocusTarget(this.toggleId)
    this.props.handleSort(sortValue)
  }

  renderSortView = options => {
    let selected = options?.selected

    if (options?.selected || options?.key == this.selectedSortId) {
      selected = 'active'
    }

    return (
      <Dropdown.Item
        data-testid="qa-sort-options"
        className={`plp-sort-option ${selected}`}
        key={options.name}
        eventKey={options.key}>
        {options.name}
      </Dropdown.Item>
    )
  }

  toggleDirection = isToggle => {
    if (isToggle) {
      this.direction = 'up'
    } else {
      this.direction = 'down'
    }
  }
  render() {
    const sortOptions = addDefaultSort(this.props)
    /* filtering these items based on backend team's input
     * https://nuskin.atlassian.net/browse/CX121-2479
     */
    const filteredByKey = sortOptions.filter(
      option =>
        option?.key != 'sort_string_product_name ASC' &&
        option?.key != 'sort_string_product_name DESC' &&
        option?.key != 'sort_number_relevancyRank ASC' &&
        option?.key != 'sort_number_relevancyRank DESC'
    )
    const view = filteredByKey.map(this.renderSortView)
    const size = application?.isMobile ? true : false
    const isMysiteAdmin = IS_BROWSER
      ? window.location.pathname?.includes(pageNames.mysiteAdmin)
      : false
    const isProductOfferAdmin = this.currentPathname?.includes(
      pageNames.productOfferAdmin
    )
    return (
      <div className="plp-sort-container" ref={this.sortWrapperRef}>
        <div className="sortby-title d-flex">
          <span
            className={`text-captialize sortByLabel ${enablePlpRedesign ? '' : 'd-none'} d-md-flex`}>
            {i18nTranslate('plp.sortByText', 'Sort By', {
              nameSpace: this.nameSpace,
            })}
            {this.props.isMysiteRedesign ? (
              <IoIosSwap style={{ transform: 'rotate(90deg)' }} />
            ) : (
              `:`
            )}
          </span>
          {/* <span className="d-sm-none sortby-colon">:</span> */}
          {/* <img className="sortby-icon" src={sortByIcon} alt="" /> */}
        </div>

        <DropdownButton
          id={this.toggleId}
          data-testid="qa-plp-sort"
          alignRight={size}
          variant="none"
          className={`plp-sort-wrap plp-sort-${this.direction} ${
            this.props.isMysiteRedesign &&
            (isMysiteAdmin ||
              isProductOfferAdmin ||
              window.location.pathname?.includes('/mysite-'))
              ? 'mysite-sort-redesign'
              : ''
          }`}
          drop={'down'}
          title={this.selectedSortOption}
          onSelect={this.handleSort}
          onToggle={this.toggleDirection}>
          {view}
        </DropdownButton>
      </div>
    )
  }
}

export { ProductSort }
export default ProductSort
